import getSdks from "./sdks";
import { logError, ERROR_TYPE } from "./newRelicLogger";

export async function getCustomerSegmentIds() {
  try {
    const audience = await getSdks().audience;
    const segments = await audience.getSegments();
    if (!segments.length) {
      return null;
    }
    return segments.map(({ segmentId }) => segmentId).join(",");
  } catch (error) {
    logError(ERROR_TYPE.SdkError, {
      sdk: "audience",
      action: "getSegments",
      message: error.message,
    });
    return null;
  }
}
